import { useSearchParams, useNavigate } from "react-router-dom";

// Dev-only stand-in for the funkit checkout page. Lets us test the full
// donor → webhook → overlay loop without real payment rails.
export default function FakeCheckout(): JSX.Element {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session");
  const handle = params.get("handle");
  const amount = params.get("amount");

  async function complete(): Promise<void> {
    if (!sessionId) return;
    await fetch("/webhooks/funkit", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Funkit-Dev": "1" },
      body: JSON.stringify({ type: "payment.succeeded", session_id: sessionId }),
    });
    if (handle) nav(`/${handle}`);
  }

  return (
    <section className="card stack" style={{ maxWidth: 480, margin: "60px auto" }}>
      <h1>Dev Checkout</h1>
      <p>Session: <code>{sessionId ?? "(none)"}</code></p>
      <p>Amount: <strong>${amount ?? "0"}</strong></p>
      <button className="btn btn-primary" onClick={complete}>Simulate payment success</button>
    </section>
  );
}
